import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useUiText } from '@clavian/i18n/react';
import { cx } from '../lib/cx.js';
const ringSize = {
    sm: 'var(--clavian-icon-sm)',
    md: 'var(--clavian-icon-md)',
    lg: 'var(--clavian-icon-lg)',
};
export function Spinner({ size = 'md', label, labelHidden = false, className, }) {
    const t = useUiText();
    const text = label ?? t('loading');
    return (_jsxs("span", { className: cx('clav-spinner', className), role: "status", children: [_jsx("span", { className: "clav-spinner__ring", style: { width: ringSize[size], height: ringSize[size] } }), _jsx("span", { className: labelHidden ? 'clav-visually-hidden' : undefined, children: text })] }));
}
//# sourceMappingURL=spinner.js.map